import { APIHandler } from "utilities/apiHandler";

import { SelectionConfig } from "entity/selection/SelectionListContainer/SelectionListContainer.types";

export interface ISelectionListContainerHandler {
    getConfig(jobId: number): Promise<SelectionConfig>;
}

export class SelectionListContainerHandler implements ISelectionListContainerHandler {
    async getConfig(jobId: number): Promise<SelectionConfig> {
        return await APIHandler(`/api/Selections/Config`, {
            method: "GET",
            data: { jobId },
            responseType: SelectionConfig,
        });
    }
}
